export default "__VITE_ASSET__ZfPDlBYG__"